import React from 'react';

import { Flex, IconButton, Select, Text, Tooltip } from '@chakra-ui/react';
import { ArrowRightIcon, ArrowLeftIcon, ChevronRightIcon, ChevronLeftIcon } from '@chakra-ui/icons';
import { PaginationType } from '../../hooks/useFetch';

interface PaginatorProps {
  pagination: PaginationType;
  queryParams: any;
  setQueryParams: any;
}

export const Paginator = ({ pagination, queryParams, setQueryParams }: PaginatorProps) => {
  return (
    <Flex justifyContent="end" alignItems="center">
      <Flex>
        <Tooltip label="Primeira página">
          <IconButton
            onClick={() => setQueryParams(old => ({ ...old, page: 1 }))}
            isDisabled={!pagination?.has_prev}
            icon={<ArrowLeftIcon h={3} w={3} />}
            mr={4}
            aria-label=""
          />
        </Tooltip>
        <Tooltip label="Página anterior">
          <IconButton
            onClick={() => setQueryParams(old => ({ ...old, page: old.page - 1 }))}
            isDisabled={!pagination?.has_prev}
            icon={<ChevronLeftIcon h={6} w={6} />}
            mr={4}
            aria-label=""
          />
        </Tooltip>
      </Flex>

      <Flex alignItems="center">
        <Text flexShrink="0" mr={8}>
          Página{' '}
          <Text fontWeight="bold" as="span">
            {pagination?.current_page}
          </Text>{' '}
          de{' '}
          <Text fontWeight="bold" as="span">
            {pagination?.total_pages}
          </Text>
        </Text>
        <Select
          minW={38}
          value={queryParams?.per_page}
          defaultValue={10}
          onChange={e => {
            setQueryParams(old => ({ ...old, page: 1, per_page: Number(e.target.value) }));
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Mostrar {pageSize}
            </option>
          ))}
        </Select>
      </Flex>

      <Flex>
        <Tooltip label="Próxima página">
          <IconButton
            onClick={() => setQueryParams(old => ({ ...old, page: old.page + 1 }))}
            isDisabled={!pagination?.has_next}
            icon={<ChevronRightIcon h={6} w={6} />}
            ml={4}
            aria-label=""
          />
        </Tooltip>
        <Tooltip label="Ultima página">
          <IconButton
            onClick={() => setQueryParams(old => ({ ...old, page: pagination?.total_pages }))}
            isDisabled={!pagination?.has_next}
            icon={<ArrowRightIcon h={3} w={3} />}
            ml={4}
            aria-label=""
          />
        </Tooltip>
      </Flex>
    </Flex>
  );
};
